import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';

import { customClamshellService } from 'services';
import { DeleteTemplateParams } from 'types';
import { displayNotification } from 'utils';

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ templateCode }: DeleteTemplateParams) => {
      return customClamshellService.deleteTemplate(templateCode);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries([ServerStateKeysEnum.clamshellTemplates]);
      },
      onError: () => {
        displayNotification('Failed to delete the template!', 'danger');
      },
    }
  );
};
